"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Patient_Contact = exports.Patient_ContactGenderKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_HumanName_1 = require("./RTTI_HumanName");
var RTTI_ContactPoint_1 = require("./RTTI_ContactPoint");
var RTTI_Address_1 = require("./RTTI_Address");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Period_1 = require("./RTTI_Period");
var Patient_ContactGenderKind;
(function (Patient_ContactGenderKind) {
    Patient_ContactGenderKind["_male"] = "male";
    Patient_ContactGenderKind["_female"] = "female";
    Patient_ContactGenderKind["_other"] = "other";
    Patient_ContactGenderKind["_unknown"] = "unknown";
})(Patient_ContactGenderKind = exports.Patient_ContactGenderKind || (exports.Patient_ContactGenderKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Patient_Contact = t.recursion('IPatient_Contact', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        relationship: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        name: RTTI_HumanName_1.RTTI_HumanName,
        telecom: t.array(RTTI_ContactPoint_1.RTTI_ContactPoint),
        address: RTTI_Address_1.RTTI_Address,
        gender: (0, EnumType_1.createEnumType)(Patient_ContactGenderKind, 'Patient_ContactGenderKind'),
        _gender: RTTI_Element_1.RTTI_Element,
        organization: RTTI_Reference_1.RTTI_Reference,
        period: RTTI_Period_1.RTTI_Period
    });
});
//# sourceMappingURL=RTTI_Patient_Contact.js.map